import React from 'react'
import {removeZeros} from '../../../utils/misc'

export class SavePurchaseBtn extends React.Component {

  render() {
    if(this.props.working) {
      return <button className="btn btn-primary" disabled>Saving...</button>
    }
    else {
      return <button className="btn btn-primary" onClick={(e)=>{this.props.handleSavePurchase(e)}}>Save Purchase</button>
    }
  }
}

export class AddPurchaseRow extends React.Component {

  render() {
    return <button className="btn btn-info btn-sm" onClick={(e)=>{this.props.handleAddRow(e)}}>Add Row</button>
  }
}

export class Hsn extends React.Component {
  render(){
    return <div className="text-vcenter-sm">{this.props.item.hsn}</div>
  }
}

export class Price extends React.Component {
  render() {
    return <div className="text-vcenter-sm">{removeZeros(this.props.item.price)}</div>
  }
}

export class Tax extends React.Component {
  render() {
    return <input tabIndex="-1" type="number" name="tax" step=".01" className="form-control "  value={this.props.item.tax}  readOnly/>
  }
}

export class Cgst extends React.Component {
  render() {

    let item = this.props.item
    let inputValue = this.props.item.cgst_amount
    if(typeof item.gst !== "undefined" && item.gst !== null && typeof item.gst.cgst !== "undefined") {
       inputValue = Number(inputValue) + " (" + Number(item.gst.cgst) + "%)"
    }
    return <div className="text-vcenter-sm">{inputValue}</div>
    //return <input tabIndex="-1" type="text" name="cgst" step=".01" className="form-control input-sm "  value={inputValue}  readOnly/>
  }
}
export class Sgst extends React.Component {
  render() {
    let item = this.props.item
    let inputValue = this.props.item.sgst_amount
    if(typeof item.gst !== "undefined" && item.gst !== null && typeof item.gst.sgst !== "undefined") {
       inputValue = Number(inputValue) + " (" + Number(item.gst.cgst) + "%)"
    }
    return <div className="text-vcenter-sm">{inputValue}</div>
  }
}
export class Igst extends React.Component {
  render() {
    let item = this.props.item
    let inputValue = this.props.item.igst_amount
    if(typeof item.gst !== "undefined" && item.gst !== null && typeof item.gst.igst !== "undefined") {
       inputValue = Number(inputValue) + " (" + Number(item.gst.igst) + "%)"
    }
    return <div className="text-vcenter-sm">{inputValue}</div>
  }
}


export class Total extends React.Component {
  render() {
    var total = parseFloat(this.props.item.total)
    return <div className="text-vcenter-sm">{total}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/others.js